import React from 'react'
import { connect } from 'react-redux'
import { Col, Container, Row, Table } from 'reactstrap'
import { translate } from "views/utils/translate";
import { MarketData } from "react-ts-tradingview-widgets";

const MarketDataSymbolsGroup = [
    {
        "name": "Forex",
        "originalName": "Forex",
        "symbols": [
            {
                "name": "FX:EURUSD",
                "displayName": "EUR to USD"
            },
            {
                "name": "FX:GBPUSD",
                "displayName": "GBP to USD"
            },
            {
                "name": "FX:USDJPY",
                "displayName": "USD to JPY"
            },
            {
                "name": "FX:USDCHF",
                "displayName": "USD to CHF"
            },
            {
                "name": "FX:AUDUSD",
                "displayName": "AUD to USD"
            },
            {
                "name": "FX:USDCAD",
                "displayName": "USD to CAD"
            }
        ]
    }
]

function ForexContent(props) {
    return (
        <>
            <div className='forexContent px-4 px-lg-0'>
                <Container className='w-100'>
                    <Row className='justify-content-center align-items-stretch mx-0 w-100'>
                        <Col lg={12} md={12} sm={12} xs={12} className='mb-3 mt-4'>
                            <span className='font-Bold sectionDivTitle text-white d-block text-left mb-3'>
                                {translate(props.lang, "Live Chart")}
                            </span>
                            <div className='contentLiveChartBox'>
                                <MarketData colorTheme="dark" locale={props.lang === "ZH" ? "zh_CN": "en"} isTransparent={true} symbolsGroups={MarketDataSymbolsGroup} width="100%" />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}

const mapStateToProps = state => {
    const { i18n } = state;
    return {
        lang: i18n.lang
    }
}

export default connect(mapStateToProps)(ForexContent);